/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getMemberOverrides';

export type GetMemberPathParams = NonNullable<operations['getMember']['parameters']['path']>;

export type GetMemberQueryParams = NonNullable<operations['getMember']['parameters']['query']>;

export interface Input extends GetMemberPathParams {
  apiVersion?: string;
  query?: GetMemberQueryParams;
}

export async function getMember(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/members/{id}', {
    params: { path, query },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
